import React from 'react';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#00aae9',
      dark: '#0593e6',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

const CircularLoading: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CircularProgress style={{ position: 'relative', top: '50%', left: '50%' }} color="primary" />
    </ThemeProvider>
  );
};

export { CircularLoading };
